<template>
  <el-container direction="vertical">
    <el-row>
      <el-col :span="5">
        <el-input v-model="params.role_name" prefix-icon="el-icon-search" placeholder="输入角色名称查询" clearable @change="onSearch()" />
      </el-col>

      <el-col :span="5" class="col_pos_right" align="right">
        <el-button v-permission="'新增角色'" icon="el-icon-plus" @click="addRole()">添加角色</el-button>
        <el-button class="btn btn_1" @click="onSearch()">刷新</el-button>
      </el-col>
    </el-row>

    <el-container>
      <el-table :data="pageData.items" stripe border :height="$setTableHeight(1, 0)" :header-cell-style="{textAlign: 'center'}" :cell-style="{textAlign: 'center'}">
        <el-table-column v-for="it in tableColList" :key="it.key" :label="it.name" :fixed="it.fixed">
          <template slot-scope="scope">{{scope.row[it.key]}}</template>
        </el-table-column>

        <el-table-column fixed="right" width="220" label="操作">
          <template slot-scope="scope">
            <el-link v-for="item in $operationsFilter(operations)" :key="item.key" :type="item.type" :disabled="item.disabled && item.disabled(scope.row.role_id)" @click="handleClick(item.operation, scope.row)">{{ item.title }}</el-link>
          </template>
        </el-table-column>
      </el-table>
    </el-container>

    <el-pagination
      background
      style="margin-top:14px"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageData.total"
      :current-page="pageData.page"
      @current-change="onPageChange"
      :page-size="params.max_results"
      :page-sizes="$pageSizes"
      @size-change="onPageSizeChange">
    </el-pagination>

    <el-dialog width="600px" :title="title" :visible.sync="dialogVisible" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" @closed="componet_select = ''">
      <component :is="componet_select" :rowData="rowData" @tableCloseDialog="dialogVisible = false" />
    </el-dialog>
  </el-container>
</template>

<script>
import Backend from '@/api/backend'
import roleAdd from './add'
import roleEdit from './edit'
import roleAssign from './assign'

export default {
  data () {
    return Backend.initListPage(this, 'role', {
      route_name: '角色管理列表',
      id_name: 'role_id',
      tableColList: [
        {
          key: 'role_id',
          name: '角色ID',
          fixed: true
        },
        {
          key: 'role_name',
          name: '角色名称'
        },
        {
          key: 'remark',
          name: '备注'
        }
      ],
      operations: [
        {
          key: 'assign',
          title: '分配权限',
          icon: 'icon-zhongzhimima icon_11',
          permiss: '分配权限',
          type: 'success',
          operation: 'assignRow'
        },
        {
          key: 'edit',
          title: '编辑',
          icon: 'icon-bianji icon_1',
          permiss: '编辑角色',
          type: 'primary',
          operation: 'editRow',
          disabled: (id) => { return Number(id) < 6 }
        },
        {
          key: 'delete',
          title: '删除',
          icon: 'icon-shanchu icon_6',
          permiss: '删除角色',
          type: 'danger',
          operation: 'deleteRow',
          disabled: (id) => { return Number(id) < 6 }
        }
      ],
      params: {
        role_name: ''
      },
      dialogVisible: false,
      title: '',
      componet_select: '',
      rowData: {}
    })
  },
  components: {
    'role-add': roleAdd,
    'role-edit': roleEdit,
    'role-assign': roleAssign
  },
  methods: {
    addRole () {
      this.title = '添加角色'
      this.dialogVisible = true
      this.componet_select = 'role-add'
    },
    onSearch () {
      Backend.queryList(this, this.pageData.filter, 0)
    },
    onPageChange (v) {
      Backend.queryList(this, this.pageData.filter, v)
    },
    onPageSizeChange (v) {
      this.params.max_results = v
      Backend.queryList(this, this.pageData.filter, this.pageData.page === 0 ? 1 : this.pageData.page)
    },
    handleClick (operation, row) {
      this[operation](row)
    },
    assignRow (row) {
      this.title = '分配权限'
      this.dialogVisible = true
      this.componet_select = 'role-assign'
      this.rowData = row
    },
    editRow (row) {
      this.title = '编辑角色'
      this.dialogVisible = true
      this.componet_select = 'role-edit'
      this.rowData = row
    },
    deleteRow (row) {
      Backend.deleteRow(this, row, '角色管理')
    }
  }
}
</script>
